// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__peEdi","footer":"NavbarSimple_footer__kbRfv","link":"NavbarSimple_link__njuMV","linkIcon":"NavbarSimple_linkIcon__el9f1"};